$(document).ready(function () {
    // Check we can actually load the tinymce editor
    let tinyMceConfig = window.tinyMceConfig || {};

    if (tinyMceConfig && window.tinymce && $(tinyMceConfig.selector).length > 0) {
        window.tinymce.init(tinyMceConfig);
    }
});



// WEBPACK FOOTER //
// ./src/js/legacy/js/tinymce-loader.js